import React, { useEffect, useState } from "react";
import RoutePath from "./../../routes";
import TopNavbar from "../../common/upper-navbar/top-navbar";
import Navbar from "./../../common/navbar/Navbar";
import { Box, useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import { styled, useTheme } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";

const drawerWidth = 240;
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
        marginTop: 0,
        [theme.breakpoints.up('md')]: {
            ...(open && {
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginLeft: `${drawerWidth}px`,
            }),
        },
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2),
            marginLeft: 0,
        }
    }),
);


function Approot({ admin, isLoggedIn }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isInventoryManager = admin?.Role?.name?.toLowerCase()?.includes('inventory');
    const [open, setOpen] = useState(!isMobile && !isInventoryManager);
    const location = useLocation();
    const [openLogin, setLoging] = useState(false);
    const [inboxOpen, setInboxOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const isPrint = location?.pathname?.includes("/invoice");
        if (location?.pathname === "/login") {
            setLoging(true);
            setOpen(false);
            setInboxOpen(false);
        } else if (location?.pathname === "/forgot-password") {
            setInboxOpen(true);
            setLoging(false);
            setOpen(false);
        } else if (location?.pathname?.split("/")?.[1] === "reset-password") {
            setInboxOpen(true);
            setLoging(false);
            setOpen(false);
        } else if (isPrint) {
            setInboxOpen(false);
            setLoging(false);
            setOpen(false);
        }
        else {
            setLoging(false);
            setInboxOpen(false);
            setOpen(!isMobile && !isInventoryManager);
        }
    }, [location, isMobile, isInventoryManager])

    useEffect(() => {
        if (isLoggedIn === 'false') {
            navigate("/login");
        }
    }, [isLoggedIn]);

    const isPrintView = location?.pathname?.includes("/invoice");

    return (
        <Box>
            {isPrintView ? null : <TopNavbar isLoggedIn={isLoggedIn} />}
            <Box >
                {openLogin || inboxOpen || isPrintView ? null :
                    (<Navbar open={open} setOpen={setOpen} admin={admin}   />)}
                <Box flexGrow={1} minHeight={inboxOpen ? "" : "100vh"}>
                    <Box sx={{ marginTop: (openLogin || isPrintView) ? "0px" : "40px", }}>
                        {openLogin || isPrintView ? (
                            <RoutePath />
                        ) : (
                            <Main open={open}>
                                <RoutePath />
                            </Main>
                        )}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default Approot;
